const SIZES = {
  sm: { pad: '3px 8px',   font: 11,                          border: 2 },
  md: { pad: '5px 12px',  font: 13,                          border: 3 },
  lg: { pad: '10px 18px', font: 'clamp(11px, 3.2vw, 20px)', border: 4 },
  xl: { pad: 'clamp(8px, 2vw, 14px) clamp(10px, 3vw, 24px)', font: 'clamp(11px, 3.5vw, 28px)', border: 5 },
};

export function VerdictStamp({ type, size = 'md', rotate = -4, invert = false }) {
  if (!type) return null;
  const s   = SIZES[size] || SIZES.md;
  const bg  = invert ? '#0a0a0a' : '#ff5a1f';
  const fg  = invert ? '#ff5a1f' : '#0a0a0a';
  return (
    <div style={{
      display: 'inline-block',
      padding: s.pad,
      background: bg,
      color: fg,
      border: `${s.border}px solid ${fg}`,
      fontFamily: "'Archivo Black', sans-serif",
      fontSize: s.font,
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      transform: `rotate(${rotate}deg)`,
      filter: `drop-shadow(3px 3px 0 ${fg})`,
      whiteSpace: 'nowrap',
      flexShrink: 0,
    }}>
      {type.toUpperCase()}
    </div>
  );
}

export function VerdictBlock({ data }) {
  if (!data?.type && !data?.thoughts) return null;
  return (
    <div id="post-verdict" style={{
      background: '#0a0a0a',
      color: '#f2ece1',
      padding: 'clamp(20px, 5vw, 36px) clamp(16px, 5vw, 32px)',
      margin: '48px 0',
      border: '3px solid #ff5a1f',
    }}>
      <div style={{
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: 11,
        color: '#ff5a1f',
        letterSpacing: '0.25em',
        textTransform: 'uppercase',
        marginBottom: 12,
      }}>
        {'// FINAL VERDICT'}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 'clamp(16px, 4vw, 32px)', flexWrap: 'wrap' }}>
        {data.type && <VerdictStamp type={data.type} size="xl" rotate={-4} />}
        {data.thoughts && (
          <p style={{ fontSize: 'clamp(15px, 3vw, 20px)', lineHeight: 1.4, flex: 1, minWidth: 0, flexBasis: '200px', margin: 0 }}>
            {data.thoughts}
          </p>
        )}
      </div>
    </div>
  );
}
